import { type RefObject } from 'react';
import { Button } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';
import { UploadFileProgress } from 'modules/files';
import spinnerTitle from 'components/others/spinnerTitle';
import AiInfoBlock from 'components/others/AiInfoBlock';
import SolarIcon from 'components/icons/SolarIcon';

interface ObjectCustomerAiPanelProps {
    isBusy: boolean;
    handleOpenClick: () => void;
    processingLabel: string;
    phase: 'idle' | 'uploading' | 'processing';
    handleCancel: () => void;
    uploadProgress: number | boolean;
    refInputFile?: RefObject<HTMLInputElement | null>;
    handleChangeFile: () => void;
}

const ObjectCustomerAiPanel = ({
    isBusy,
    handleOpenClick,
    processingLabel,
    phase,
    handleCancel,
    uploadProgress,
    refInputFile,
    handleChangeFile,
}: ObjectCustomerAiPanelProps) => {
    const { t } = useTranslation(['Objects']);

    return (
        <AiInfoBlock title={t('customerAi.infoTitle')}>
            <p>{t('customerAi.infoText')}</p>
            <div className="ai-info-block-formats">
                <span className="ai-info-block-formats-label">{t('customerAi.formatsLabel')}</span>
                {t('customerAi.formatsList')}
            </div>
            <div className="d-flex flex-wrap gap-2 mt-3">
                <Button type="button" variant="primary" size="sm" onClick={handleOpenClick} disabled={isBusy}>
                    {spinnerTitle(
                        <>
                            <SolarIcon name="stars" className="me-1" />
                            {t('customerAi.open')}
                        </>,
                        isBusy,
                        processingLabel,
                    )}
                </Button>
                {phase === 'processing' && (
                    <Button type="button" variant="outline-danger" size="sm" onClick={handleCancel}>
                        <SolarIcon name="stop-circle" className="me-1" />
                        {t('customerAi.cancel')}
                    </Button>
                )}
            </div>
            <div className="small text-muted mt-2">
                <Trans i18nKey="customerAi.editHint" ns="Objects" components={{ strong: <strong /> }} />
            </div>
            {uploadProgress !== false && (
                <div className="pt-2">
                    <UploadFileProgress progress={Number(uploadProgress)} />
                    <div className="small text-muted mt-2">{processingLabel}</div>
                </div>
            )}
            <input ref={refInputFile} type="file" className="d-none" onChange={handleChangeFile} />
        </AiInfoBlock>
    );
};

export default ObjectCustomerAiPanel;
